

export class KadyChainConversationListHolder
{
    shortSummaryGuidHolders:shortSummaryGuidHolders[];
}
export class shortSummaryGuidHolders
{
    guid:string;
    shortSummary:string;
}
export class KadyChainConversation
{
    ConversationID: string;
    BotName: string;
    Responses: KaddyChainAudioResponsePair[];
    CreationTimeUtc: Date;
    currentChatLog:Message;
    summarizedConversation: string;
    shortSummarizedConversation: string;
}
export class KadyChainDailyConversations
{
    Date: Date;
    Conversations: KadyChainConversation[];
}
export enum CreatorType
{
    Bot,
    Student,
    Account //Teacher, Parent, etc
}

export class KaddyChainAudioResponsePair
{  
    CreationTimeUtc: Date;
    BotResponseAudio:AudioResponse;
    StudentResponse:AudioResponse;

}
export class AudioResponse
{  creatorType:CreatorType;
    artifactID:string;
}
export class Message
{
    role:string;
    content:string;
}
export function sortConversationsByDate(conversations: KadyChainConversation[]): KadyChainConversation[] {
    return conversations.sort((a, b) => {
        return new Date(b.CreationTimeUtc).getTime() - new Date(a.CreationTimeUtc).getTime();
    })};
export function sortDailyConversationsByDate(conversations: KadyChainDailyConversations[]): KadyChainDailyConversations[] {
    return conversations.sort((a, b) => {
        return new Date(b.Date).getTime() - new Date(a.Date).getTime();
    })};